module.exports = __webpack_public_path__ + "static/media/76.d854b845.jpg";